import storage from "local-storage-fallback";

import { privateClient } from "./client";

const fetchRechargeValues = () =>
  privateClient.get(`/customers/${storage.getItem("identifier")}/products`);

export { fetchRechargeValues };
